import { getNextSiblings } from './utils';
import { debounce } from './utils';

function moveFullWidthComponentBlocks() {
  const placeHolderElement = document.querySelector('#full-width-components-placeholder');

  const firstFullWidthComponentOnPage = document.querySelector('.full-width-component')?.closest('.paragraph');

  if (!placeHolderElement || !firstFullWidthComponentOnPage) return;

  const nextSiblings = getNextSiblings(firstFullWidthComponentOnPage);
  const components = [firstFullWidthComponentOnPage, ...nextSiblings];

  if (components.length > 0) {
    components.forEach((el) => {
      placeHolderElement.appendChild(el);
      el.classList.add('ready');
    });
  }
}

window.addEventListener('DOMContentLoaded', () => {
  moveFullWidthComponentBlocks();
});